import React from "react";
import { Reveal } from "./Reveal";
import { STATEMENT } from "../data/copy";

/**
 * Section 3 — Statement. Full viewport, porcelain, serif.
 * "reimagined" rendered mint-ink italic.
 */
export const Statement = () => {
  return (
    <section id="statement" className="mk-statement" data-testid="statement-section">
      <Reveal as="p" className="mk-statement__quote" data-testid="statement-quote">
        {STATEMENT.pre}
        <em>{STATEMENT.accent}</em>
        {STATEMENT.post}
      </Reveal>
    </section>
  );
};

export default Statement;
